// Meta Pixel tracking utilities
// Pixel ID: 1660451618516345

/**
 * Track a ViewContent event
 * @param {object} params - Event parameters
 */
export const trackViewContent = (params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'ViewContent', params);
  }
};

/**
 * Track a Lead event (questionnaire submission)
 * @param {object} leadData - Lead information
 */
export const trackLead = (leadData = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'Lead', {
      content_name: 'Seller Questionnaire',
      content_category: 'Real Estate Lead',
      ...leadData
    });
  }
};

/**
 * Track a custom event
 * @param {string} eventName - Name of the custom event
 * @param {object} params - Event parameters
 */
export const trackCustomEvent = (eventName, params = {}) => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('trackCustom', eventName, params);
  }
};

/**
 * Track PageView (already auto-tracked, but available for SPA navigation)
 */
export const trackPageView = () => {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView');
  }
};
